import { createFileRoute } from '@tanstack/react-router'
import type { DatabaseVendor } from '@/features/instances/types'
import { TemplateCreatePage } from '@/features/agent-templates/template-create-page'
import type { AgentTemplateJobType } from '@/features/agent-templates/types'

type CreateTemplateSearch = {
  vendor?: DatabaseVendor
  jobType?: AgentTemplateJobType
}

const validJobTypes: AgentTemplateJobType[] = [
  'diag_sql',
  'tool_exec',
  'vacuum_analyze',
  'optimize',
  'diagnostic_collection',
  'backup',
  'restore',
]

export const Route = createFileRoute('/_authenticated/automation/templates/create')({
  component: TemplateCreatePage,
  validateSearch: (search: Record<string, unknown>): CreateTemplateSearch => {
    const vendor =
      search.vendor === 'postgres' ||
      search.vendor === 'mysql' ||
      search.vendor === 'mongodb'
        ? (search.vendor as DatabaseVendor)
        : undefined

    const jobType =
      typeof search.jobType === 'string' &&
      validJobTypes.includes(search.jobType as AgentTemplateJobType)
        ? (search.jobType as AgentTemplateJobType)
        : undefined

    return { vendor, jobType }
  },
})
